import React from "react";
import "./contributions-confirmation.scss";
import { Icons } from "../../atoms/Icons";
import { Col } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import { Link } from "react-router-dom";
import CustomCheckbox from "../../atoms/CustomCheckbox";

const ContributionsConfirmationModal = (props) => {
  return (
    <>
      <Link to="" className="text-end">
        <Icons
          iconname="close"
          variant="icon-twenty-four-px"
          clickHandler={props.handleCloseButton}
        />
      </Link>
      <p className="heading">{props.modalTitle}</p>
      {props.modalTitle === "Feedback confirmation" ? (
        <span>Feedback submitted successfully</span>
      ) : props.modalTitle === "Thanks for getting in touch" ? (
        <div>
          <span>
            We have received you enquiry, you will shortly receive confirmation
            by email.
          </span>
        </div>
      ) : props.parentFile === "manage-other-pots" ? (
        <div>
          <div className="pension-lab-consent">
            By clicking on this link, you will be transferred to Pension
            Lab&apos;s website and we will transfer some of your personal data
            to Pensions Lab which may be used to support the tracking of your
            pensions.
            <br /> Pension Lab is an independent data controller and is
            responsible for how and why your data is processed if you choose to
            visit its pages or submit information there. Once you click through,
            your use of their site is governed by Pension Lab’s own privacy
            notice and terms.
          </div>
          <br />
          <CustomCheckbox
            name={"pensionLab"}
            type="checkbox"
            label={
              "Please tick the box to confirm your consent to our transferring of your personal data to Pension Lab and to their privacy notice."
            }
            variantName="custom-checkbox pension-lab-checkbox"
            checked={props.consent}
            onChange={() => {
              props.setConsent(!props.consent);
            }}
          />
        </div>
      ) : (
        <>
          <span>
            We have received your contribution request and will inform your
            employer.
          </span>
          <span>
            {" "}
            Changes to contributions are usually from 1st of the following month
            but this is subject to your usual payroll processes.
          </span>
          <span>
            {" "}
            National minimum wage and your employer&apos;s rules regarding
            salary sacrifice may also apply.
          </span>
        </>
      )}
      {props.modalTitle === "Thanks for getting in touch" ||
      props.modalTitle === "Updating your contributions" ? (
        <Col>
          <div className="get-in-touch-cta">
            <Buttons
              className="primary"
              name="Got it!"
              handleClick={props.handleCloseButton}
            />
          </div>
        </Col>
      ) : (
        <Col>
          <div className="get-in-touch-cta">
            <Buttons
              className="tertiary mt-4"
              name="Track my other pensions"
              handleClick={props.handlePensionLabLinkClick}
              disabled={!props.consent}
            />
          </div>
        </Col>
      )}
    </>
  );
};

export default ContributionsConfirmationModal;
